import { CommonModule }               from '@angular/common';
import { NgModule }                   from '@angular/core';
import {
	FormsModule,
	ReactiveFormsModule
}                                     from '@angular/forms';
import { NgbCollapseModule }          from '@ng-bootstrap/ng-bootstrap';
import { FormDatepickerModule }       from '@shared/form-elements/form-datepicker/form-datepicker.module';
import { FormInputModule }            from '@shared/form-elements/form-input/form-input.module';
import { FormSelectModule }           from '@shared/form-elements/form-select/form-select.module';
import { NaturalPersonFormComponent } from './natural-person-form.component';


@NgModule( {
	declarations: [
		NaturalPersonFormComponent
	],
	imports: [
		// Angular
		CommonModule,
		FormsModule,
		ReactiveFormsModule,

		// Third Party
		NgbCollapseModule,

		// Shared
		FormDatepickerModule,
		FormInputModule,
		FormSelectModule
	],
	exports: [
		NaturalPersonFormComponent
	],
	providers: [ ]
} )
export class NaturalPersonFormModule {}
